<!DOCTYPE html>
<html lang="en">

<head>
  <meta charset="UTF-8">
  <meta http-equiv="X-UA-Compatible" content="IE=edge">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <link href='https://fonts.googleapis.com/css?family=Roboto' rel='stylesheet'>
  <title>Document</title>
</head>

<body>
  <div class="main">
    <div class="row">
      <!-- Header -->
      <div class="row headerListBook">
        <div class="col-12 p-2">
          <p>{{'my_books.all_prodcts_mb' | translate}}</p>
        </div>
        <div class="col-7"></div>
        <br>
      </div>
      <div class="row">
        <div class="col">
          <div class="row">
            <div class="col">
              <p class="descriptionViewListBook">
                {{'my_books.message_my_books_mb' | translate}}
              </p>
            </div>
          </div>
          <br>
          <div class="row">
            <ng-container *ngIf="dataSource.data.length > 0 else elseTemplate">
              <div class="mat-elevation-z8">
                <table mat-table [dataSource]="dataSource">

                  <!-- Image Column -->
                  <ng-container matColumnDef="imgName">
                    <th mat-header-cell *matHeaderCellDef class="sizeThead text-center">
                      <p>{{'my_books.image_mb' | translate}}</p>
                    </th>
                    <td mat-cell *matCellDef="let element" class="imgColSize">
                      <img class="imgBook" [src]="api_path_img + element.productCoverImageName" alt="vacio">
                    </td>
                  </ng-container>

                  <!-- Id -->
                  <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef class="text-center">
                      <p>{{'my_books.book_code_mb' | translate}}</p>
                    </th>
                    <td mat-cell *matCellDef="let element" class="colSize">
                      <p>{{element.id}}</p>
                    </td>
                  </ng-container>

                  <!-- ISBN -->
                  <ng-container matColumnDef="productCode">
                    <th mat-header-cell *matHeaderCellDef class="text-center">
                      <p>{{'my_books.list_product_code' |translate}}</p>
                    </th>
                    <td mat-cell *matCellDef="let element" class="colSize">
                      <p>{{element.isbn || element.issn}}</p>
                    </td>
                  </ng-container>

                  <!-- Codigo del producto -->
                  <ng-container matColumnDef="code">
                    <th mat-header-cell *matHeaderCellDef class="text-center">
                      <p>{{'my_books.book_code_mb' | translate}}</p>
                    </th>
                    <td mat-cell *matCellDef="let element" class="colSize">
                      <p>{{element.interactiveCode}}</p>
                    </td>
                  </ng-container>

                  <!-- Titulo -->
                  <ng-container matColumnDef="title">
                    <th mat-header-cell *matHeaderCellDef class="text-center">
                      <p>{{'create_product.title_crp' | translate}}</p>
                    </th>
                    <td mat-cell *matCellDef="let element" class="shortcolSize">
                      <p>{{getBookTitleByLanguage(element.id)}}</p>
                    </td>
                  </ng-container>

                  <!-- Editorial del libro -->
                  <ng-container matColumnDef="editoriaBook">
                    <th mat-header-cell *matHeaderCellDef class="text-center">
                      <button *ngIf="!isFilterVisible" (click)="showFilterInput()" class="bi bi-funnel colorIconAction"
                        [ngClass]="{'filter-active-icon': isFilterActive}"></button>
                      <b [ngClass]="{'filter-active-title': isFilterActive}"> {{'create_product.editorialBook_crp' |
                        translate}} </b>

                      <!-- Popover para el filtro -->
                      <div *ngIf="isFilterVisible" class="filter-popover popover-container">
                        <input #filterInput matInput
                          placeholder="{{'create_product.filterEditorialBook_crp' | translate}}"
                          [(ngModel)]="filterValue" (keyup)="applyFilter($event)" (blur)="hideFilterInput()">
                      </div>
                    </th>

                    <td mat-cell *matCellDef="let element" class="shortcolSize"><b>{{getEditorialBook(element.id)}}</b></td>
                  </ng-container>

                  <!-- descripcion -->
                  <ng-container matColumnDef="resume">
                    <th mat-header-cell *matHeaderCellDef class="text-center">
                      <p>{{'create_product.summary_crp' | translate}}</p>
                    </th>
                    <td mat-cell *matCellDef="let element" class="resumecolSize">
                      <p class="textDecriptionSize">{{getBookResumeByLanguage(element.id)}}</p>
                    </td>
                  </ng-container>

                  <!-- Languages -->
                  <ng-container matColumnDef="multilanguageText">
                    <th mat-header-cell *matHeaderCellDef class="text-center">
                      <p>{{'create_product.multi_language_text_crp' | translate}}</p>
                    </th>
                    <td mat-cell *matCellDef="let element" class="colSize">
                      <p *ngFor="let langName of getMultiLanguageText(element.id)">
                        <span>{{langName}}</span>
                      </p>
                    </td>
                  </ng-container>

                  <!-- instrucciones -->
                  <ng-container matColumnDef="docLink">
                    <th mat-header-cell *matHeaderCellDef class="text-center">
                      <p>{{ 'my_books.docLinkTitle' | translate }}</p>
                    </th>
                    <td mat-cell *matCellDef="let element" class="colSize">
                      <ng-container *ngIf="element.files?.length > 0; else noFiles">
                        <ng-container *ngIf="getDownloadUrl(element.files) as url">
                          <a *ngIf="url" [href]="url" download target="_blank" rel="noopener noreferrer">
                            {{ 'my_books.docLinkText' | translate }}
                          </a>
                        </ng-container>
                      </ng-container>
                      <ng-template #noFiles>
                        <span>-</span>
                      </ng-template>
                    </td>
                  </ng-container>

                  <!-- columna de cantidad para los usuarios -->
                  <!-- <ng-container matColumnDef="quantity">
                      <th mat-header-cell *matHeaderCellDef class="text-center">
                        <p>{{'create_product.quantity_crp' | translate}}</p>
                      </th>
                      <td mat-cell *matCellDef="let element" class="text-center">
                        <p>{{element.quantity}}</p>
                      </td>
                    </ng-container> -->

                  <!-- columna de disponibilidad para los admin -->
                  <ng-container matColumnDef="availability">
                    <th mat-header-cell *matHeaderCellDef class="text-center">
                      <p>{{ 'create_product.availability_crp' | translate }}</p>
                    </th>
                    <td mat-cell *matCellDef="let element" class="text-center">
                      <p>{{element.availability}}</p>
                    </td>
                  </ng-container>

                  <!-- Cantidad comprada -->
                  <ng-container matColumnDef="purchasedQuantity">
                    <th mat-header-cell *matHeaderCellDef class="text-center">
                      <p>{{ 'create_product.purchasedQuantity_crp' | translate }}</p>
                    </th>
                    <td mat-cell *matCellDef="let element" class="text-center">
                      <p>{{ element.purchasedQuantity }}</p>
                    </td>
                  </ng-container>

                  <!-- Cantidad descargada -->
                  <ng-container matColumnDef="downloadedQuantity">
                    <th mat-header-cell *matHeaderCellDef class="text-center">
                      <p>{{ 'create_product.downloadedQuantity_crp' | translate }}</p>
                    </th>
                    <td mat-cell *matCellDef="let element" class="text-center">
                      <p>{{ element.downloadedQuantity }}</p>
                    </td>
                  </ng-container>

                  <!-- eliminar y editar -->
                  <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef class="sizeThead text-center">
                      <p>{{'create_product.actions_crp' | translate}}</p>
                    </th>
                    <td mat-cell *matCellDef="let element" class="colSize">
                      <button class="btn" [routerLink]="['/book/edit-product', element.id]"><i
                          class="bi bi-pencil-fill colorIconAction"></i></button>
                      <button class="btn" (click)="deleteProduct(element)"><i
                          class="bi bi-trash-fill colorIconAction"></i></button>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                  <!-- Row shown when there is no matching data that will be provided to the wrapper table. -->
                  <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell no-data-centered" colspan="5">{{'create_product.not_products_crp' | translate}}
                    </td>
                  </tr>

                  <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell no-data-centered" colspan="5">{{'create_product.empty_crp' | translate}}</td>
                  </tr>
                </table>

                <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>

              </div>
            </ng-container>

            <ng-template #elseTemplate>
              <br><br><br>
              <div class="row text-center">
                <div class="col">
                  <h2>{{"store.not_products" | translate}}</h2>
                  <br>
                  <button class="sendAddBook" [routerLink]="['/book/shop']">{{'store.go_to_store' | translate}}</button>
                </div>
              </div>
            </ng-template>

          </div>
        </div>
      </div>
    </div>
  </div>
</body>

</html>